import { each, filter, find, map } from 'lodash-es';

import * as api from './../../api/api.service';
import * as rfps from './../../api/rfps/rfp.service';
import moment = require('moment');
import { Type } from 'noty';
import * as FeaturesApi from './../../api/features.service';
import NavMessagesFactory from '../layout/navMessages.factory';

enum offerStatus {
  COMPLETE = 'Ready',
  NO_PRICING = 'Incomplete',
}

type selectedOfersType = {
  id: boolean;
};

class ResponseNavSubmitOffersController {
  showSubmittingIndicator = false;

  isOfferSubmitted = false;

  includeOfferCount = 0;

  selectedOfers = {} as selectedOfersType;
  response: Type;

  constructor(
    private $scope,
    private $document,
    private modalPromise,
    private OfferHelper,
    private api: api.IApiService,
    private account,
    private rfp: rfps.RfpVersionTwo,
    private LoadingIndicator,
    private offers,
    private featureFlags: FeaturesApi.FeatureFlags,
  ) {
    'ngInject';

    $document.on('keydown', (e) => {
      if (e.keyCode === 27) {
        this.onClose();
      }
    });

    modalPromise.promise.finally(() => {
      $document.off('keydown');
      $document.off('click');
    });

    $document.on('click', (e) => {
      const modelElement = $document.find('.modal-dialog');
      if (modelElement && modelElement.length > 0) {
        if (!modelElement[0].contains(e.target)) {
          this.onClose();
        }
      }
    });

    if (!offers) {
      this.loadOffers().then((offers) => {
        this.renderOffers(offers);
      });
    } else {
      this.renderOffers(offers);
    }
  }

  loadOffers() {
    let loader = this.api.rfps.loadOffers(
      this.rfp.id,
      this.account.organization.id,
    );

    this.LoadingIndicator.waitFor(loader);

    loader.then((offers) => {
      this.offers = offers;
    });

    return loader;
  }

  getOfferStatusValue(offer) {
    if (
      offer.productPricingStatus === 'COMPLETE' &&
      offer.status === 'OfferSubmitted'
    ) {
      return 'Submitted';
    }
    return offerStatus[offer.productPricingStatus];
  }

  renderOffers(offers) {
    // Check whether the offers have structure set
    this.OfferHelper.updateOffers(offers);
  }

  onClose() {
    if (this.isOfferSubmitted) {
      this.closeSubmitDialog();
    } else {
      this.dismissSubmitDialog();
    }
  }

  dismissSubmitDialog() {
    this.modalPromise.reject();
    this.$scope.$hide();
  }

  closeSubmitDialog() {
    this.modalPromise.resolve(this.response);
    this.$scope.$hide();
  }

  continueSubmitOffer() {
    if (this.featureFlags.PLATFORM_OFFER_UPGRADE_RFP_945971) {
      let offerIds = Object.keys(this.selectedOfers).reduce((offers, key) => {
        if (this.selectedOfers[key]) {
          offers.push(key);
        }
        return offers;
      }, []);

      const submitLoader =
        this.api.rfps.sellers.submitOfferResponseWithGraphqlApi(
          this.rfp.id,
          offerIds,
        );

      this.LoadingIndicator.waitFor(submitLoader);

      submitLoader.then(
        (response) => {
          const hasGraphQLError = response.data?.errors?.length;

          this.response = response;
          this.isOfferSubmitted = !hasGraphQLError;

          // Graphql api error handling.
          if (hasGraphQLError) {
            NavMessagesFactory().showErrorMessage(
              response.data?.errors[0]?.message,
            );
            this.onClose();
          }
        },
        () => {
          this.isOfferSubmitted = false;
          this.onClose();
        },
      );
    } else {
      // Remove block when PLATFORM_OFFER_UPGRADE_RFP_945971 is removed
      let offers = Object.keys(this.selectedOfers).reduce((offers, key) => {
        if (this.selectedOfers[key]) {
          offers.push({
            id: key,
          });
        }
        return offers;
      }, []);

      let submitLoader = this.api.rfps.sellers.submitResponse(
        this.rfp.id,
        this.account.organization.id,
        offers,
      );

      this.LoadingIndicator.waitFor(submitLoader);

      submitLoader.then(
        (response) => {
          this.response = response;
          this.isOfferSubmitted = true;
        },
        () => {
          this.isOfferSubmitted = true;
        },
      );
    }
  }

  getExpirationDate() {
    return moment(this.rfp.expirationDate).format('MM/DD/YYYY');
  }

  includeOffer(id) {
    if (!this.selectedOfers[id]) {
      this.selectedOfers[id] = true;
    } else {
      this.selectedOfers[id] = false;
    }
    this.includeOfferCount = Object.keys(this.selectedOfers).reduce(
      (count, key) => {
        if (this.selectedOfers[key]) {
          count += 1;
        }
        return count;
      },
      0,
    );
  }

  isStatusCheckBoxVisible(offer) {
    return offer.productPricingStatus === 'COMPLETE';
  }
}

export default class ResponseNavSubmitOffersModalService {
  constructor(private $q, private $bsModal) {
    'ngInject';
  }

  openModal(
    account,
    rfp,
    offers,
    featureFlags: FeaturesApi.FeatureFlags,
  ): ng.IPromise<Type> {
    const modalPromise = this.$q.defer();

    this.$bsModal({
      locals: {
        modalPromise: modalPromise,
        account: account,
        rfp: rfp,
        offers: offers,
        featureFlags: featureFlags,
      },
      controller: ResponseNavSubmitOffersController,
      controllerAs: '$ctrl',
      show: true,
      html: true,
      placement: 'center',
      backdrop: 'static',
      keyboard: false,
      template: `<div class="modal submit-response-modal" tabindex="-1" role="dialog" data-test-selector="sumbit-offer-modal">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button data-test-selector="close-modal-btn" type="button" class="close" aria-label="Close" ng-click="$ctrl.onClose()"><i class="fa fa-times"></i></button>
                <h3 class="modal-title">Submit Offer</h3>
              </div>
              <div class="modal-body">
                <div class="modal-inner-content">
                  <div class="success" ng-if="$ctrl.isOfferSubmitted">
                    <p><b>Congratulations !</b></p>
                    <p>You have successfully responded to this RFP.</p>
                  </div>

                  <div ng-if="!$ctrl.isOfferSubmitted">
                    <div class="offers-list" style="border-bottom: 1px solid #ccc; margin-bottom: 10px; font-weight: bold;">
                      <div class="offers-col">Offers</div>
                      <div class="complete-col">Status</div>
                      <div class="status-col" style="text-align:center;">Include</div>
                    </div>
                    <div class="offers-list" ng-repeat="offer in $ctrl.offers" ng-init="offerDropdown = $ctrl.getDropdown(offer)">
                      <div class="offers-col">
                        {{ offer.name }}
                      </div>
                      <div class="complete-col">
                        {{ $ctrl.getOfferStatusValue(offer) }}
                      </div>
                      <div class="status-col" style="text-align:center;">
                        <input data-test-selector="offer-sumbit-checkbox" ng-if="offer.productPricingStatus === 'COMPLETE' && offer.status === 'OfferWorkInProgress'" type="checkbox" ng-model="selectedOfers[offer.id]" ng-change="$ctrl.includeOffer(offer.id)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button data-test-selector="offer-sumbit-selector-btn" ng-disabled="$ctrl.includeOfferCount === 0" ng-if="!$ctrl.isOfferSubmitted" type="button" class="btn btn-sm btn-primary" style="width: 100px;" ng-click="$ctrl.continueSubmitOffer()">Submit</button>
                <button data-test-selector="offer-close-button" ng-if="$ctrl.isOfferSubmitted" type="button" class="btn btn-sm btn-primary" style="width: 100px;" ng-click="$ctrl.closeSubmitDialog()">Close</button>
              </div>
            </div>
          </div>
        </div>`,
    });
    return modalPromise.promise;
  }
}
